/**
 * @generated SignedSource<<74ab49ede7051c330aefc4bc9669db81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingActionsSection_Booking$data = {
  readonly canUpdate: boolean | null | undefined;
  readonly id: string;
  readonly notesFromMember: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BookingOwner_Booking" | "CancelBookingButton_Booking" | "EditBookingButton_Booking" | "JoinBookingButton_Booking" | "MoveBookingButton_Booking">;
  readonly " $fragmentType": "BookingActionsSection_Booking";
};
export type BookingActionsSection_Booking$key = {
  readonly " $data"?: BookingActionsSection_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingActionsSection_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingActionsSection_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notesFromMember",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JoinBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoveBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingOwner_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "2512ce6c928f42d3ad0fc9e4fcb77bd4";

export default node;
